<template>
  <div>
    <HeroSection
      :nav-breadcrumbs="[
        {
          href: '/case-studies',
          title: 'Case Studies'
        }
      ]"
      :value="caseStudiesPage.hero_section"
    >
      <template v-if="caseStudiesPage.hero_section.cta" #cta>
        <HeroCta :value="caseStudiesPage.hero_section.cta" />
      </template>
    </HeroSection>

    <CaseStudiesSliderSection
      :value="caseStudiesPage.case_studies_slider_section"
      class="mb-16 hero-section hero-below-offset"
      highlight
    />

    <CaseStudiesSection
      :value="caseStudiesPage.case_studies_section"
      class="mb-16"
    />

    <PromotedResourcesSection
      :value="caseStudiesPage.promoted_resources_section"
      class="mb-16"
    />

    <DividerSection class="mb-16" />

    <ContactCtaSection
      :value="caseStudiesPage.contact_cta_section"
      class="mb-16"
    />
  </div>
</template>

<script setup>
defineProps({
  caseStudiesPage: {
    required: true,
    type: Object
  }
})
</script>
